import * as angular from 'angular';
import * as LoginPanel from './login-panel';

const module = angular.module('login-page-components', [LoginPanel.module.name]);

export { module };
